export const TRATAMIENTOS = [
  { value: "PRIMERA_CITA", label: "1ª cita", color: "#597ef7" },

  { value: "BLANQUEAMIENTO", label: "Blanqueamiento", color: "#73d13d" },
  { value: "BRAQUETS", label: "Puesta braquets", color: "#ffc53d" },

  { value: "CARILLAS", label: "Carillas", color: "#faad14" },
  { value: "CHIMENEA", label: "Chimenea", color: "#9254de" },
  { value: "CIRUGIA", label: "Cirugía", color: "#ff4d4f" },
  { value: "CORONAS", label: "Coronas", color: "#9254de" },
  { value: "CURETAJES", label: "Curetajes", color: "#faad14" },

  { value: "ENDODONCIA", label: "Endodoncia", color: "#ff4d4f" },
  { value: "EXTRACCION", label: "Extracción", color: "#ff4d4f" },

  { value: "FERULA", label: "Férula", color: "#9254de" },

  { value: "HIGIENE", label: "Higiene", color: "#73d13d" },

  { value: "MEDIDAS", label: "Medidas", color: "#9254de" },

  { value: "OBTURACION", label: "Obturación", color: "#faad14" },
  { value: "ORTODONCIA", label: "Ortodoncia", color: "#ffc53d" },

  { value: "PERNO", label: "Perno", color: "#9254de" },
  { value: "PRESUPUESTO", label: "Presupuesto", color: "#597ef7" },
  { value: "PRUEBA", label: "Prueba", color: "#597ef7" },
  { value: "PUENTE", label: "Puente", color: "#9254de" },

  { value: "RECONSTRUCCION", label: "Reconstrucción", color: "#faad14" },
  { value: "REVISION", label: "Revisión", color: "#597ef7" },

  { value: "TALLADO", label: "Tallado", color: "#faad14" },
  { value: "TORQUE", label: "Torque", color: "#ffc53d" },

  // 👨‍⚕️ DOCTORES (al final)
  { value: "LIS_ONDONTO", label: "Lis Odonto", color: "#00ffff" },
  { value: "LUCIA", label: "Lucía", color: "#39ff14" },
  { value: "LUIS", label: "Luis", color: "#ff073a" },
  { value: "MARIA", label: "María", color: "#ffff00" },
  { value: "PAOLA", label: "Paola", color: "#ff8c00" },
  { value: "ALDANA", label: "Aldana", color: "#108f1a" },
  { value: "ESTEFANIA", label: "Estefanía", color: "#0400ff" },
];